import React, { memo, useContext } from 'react';
import DefaultButton from '../molecules/DefaultButton';
import MypageReturn from '../molecules/MypageReturn';
import Paragraph from '../molecules/Paragraph';
import RowCenterButton from '../molecules/RowCenterButton';
import { FixedValuesContext } from '../context/FixedValues';

interface Props {
  mypage_opend: boolean; // マイページ開設状態
  requestModule: () => void;
}

// KWANKGM03040_事前審査結果確認フッタボタン
const FooterPreExaminationResultConfirmation: React.FC<Props> = ({
  mypage_opend,
  requestModule,
}) => {
  const { has_loan_approval } = useContext({ ...FixedValuesContext });

  return (
    <>
      {has_loan_approval && (
        <RowCenterButton>
          <DefaultButton label="借入申込をする" strong={false} handleClick={requestModule} />
        </RowCenterButton>
      )}
      {mypage_opend ? (
        <MypageReturn is_staff={false} />
      ) : (
        <Paragraph
          label="本ページを閉じる場合はウインドウまたはタブを閉じて下さい。"
          is_paragraph={false}
        />
      )}
    </>
  );
};

export default memo(FooterPreExaminationResultConfirmation);
